export const nazarenodelamor = {
	nombre: "Nazareno del Amor",
	dia: "Lunes Santo",
	nombrecompleto:
		"Venerable y Seráfica Hermandad de Penitencia de Nuestro Padre Jesús Nazareno del Amor y Nuestra Señora de la Esperanza",
	sede: "Iglesia Conventual de San Francisco",
	pasos: 2,
	distancia: [946, 1220],
	penitentes: 315,
	cargadores: 124,
	web: "http://www.diariodecadiz.es/semana_santa/Amor_0_1229277797.html",

	ida: [
		{ lng: -6.2957883, lat: 36.5346701 },
		{ lng: -6.2956703, lat: 36.5345774 },
		{ lng: -6.2958486, lat: 36.5344255 },
		{ lng: -6.2922062, lat: 36.5302864 },
		{ lng: -6.2928258, lat: 36.5297896 },
		{ lng: -6.2936398, lat: 36.5296991 },
		{ lng: -6.294525, lat: 36.5296366 },
		{ lng: -6.2946135, lat: 36.5295601 },
		{ lng: -6.295111, lat: 36.5295094 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957011, lat: 36.5290891 },
		{ lng: -6.2955227, lat: 36.5295644 },
		{ lng: -6.2954101, lat: 36.5297583 },
		{ lng: -6.2956622, lat: 36.5299523 },
		{ lng: -6.2952854, lat: 36.5303478 },
		{ lng: -6.2950172, lat: 36.5308327 },
		{ lng: -6.2949206, lat: 36.5308371 },
		{ lng: -6.294926, lat: 36.531461 },
		{ lng: -6.2964602, lat: 36.5317714 },
		{ lng: -6.2964025, lat: 36.5318479 },
		{ lng: -6.2967941, lat: 36.5325418 },
		{ lng: -6.2971522, lat: 36.5330612 },
		{ lng: -6.2984625, lat: 36.5343339 },
		{ lng: -6.2980118, lat: 36.5347477 },
		{ lng: -6.2962496, lat: 36.5339368 },
		{ lng: -6.2960163, lat: 36.5339713 },
		{ lng: -6.2963281, lat: 36.5343123 },
		{ lng: -6.2961289, lat: 36.5344195 },
		{ lng: -6.2960009, lat: 36.5344567 },
		{ lng: -6.2958553, lat: 36.5344341 },
		{ lng: -6.2956911, lat: 36.5345747 },
		{ lng: -6.295801, lat: 36.5346593 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-26T16:30",
			latlng: [36.53467, -6.29578]
		},
		{
			name: "Nueva",
			hora: "2018-03-26T17:35",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-26T18:35",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-26T19:35",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-26T20:00",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-26T20:10",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Plaza de San Francisco",
			"San Francisco",
			"Plaza de San Agustín",
			"San Francisco",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pío XII",
			"Estación de Penitencia en la S.I.C"
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena"],
		[
			"Ancha",
			"San José",
			"San Pedro",
			"Beato Diego de Cádiz",
			"Rosario (izda.)",
			"Plaza de San Francisco"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/nazarenodelamor.js